import {
  DEVELOPMENT_URL,
  PRODUCTION_URL,
  TEST_ENVIRONMENT,
} from "../constants";
import { auth } from "../firebase";

const baseUrl = TEST_ENVIRONMENT ? DEVELOPMENT_URL : PRODUCTION_URL;

const formDataEndpoints: string | any[] = [];

function presentNetworkError(
  url: string,
  method: any,
  reason = "status_not_ok"
) {
  console.error("Failed request:", url, method, reason);
}

const makeRequest = async (
  endpoint: string | number,
  method: string,
  body?: null | { [key: string]: unknown }
) => {
  const url = baseUrl + endpoint;

  let headers: any = {
    "Content-Type": "application/json",
  };

  const firebaseToken = auth.currentUser
    ? await auth.currentUser.getIdToken()
    : null;

  if (firebaseToken) {
    headers["Authorization"] = "Bearer " + firebaseToken;
  }

  let reqBody = body ? JSON.stringify(body) : null;

  if (formDataEndpoints.includes(endpoint)) {
    delete headers["Content-Type"];
    reqBody = body ? JSON.stringify(body) : null;
  }

  try {
    const controller = new AbortController();
    const signal = controller.signal;

    const id = setTimeout(() => {
      presentNetworkError(url, method, "timeout");
    }, 60000);

    const response: any = await fetch(url, {
      method,
      headers,
      body: reqBody,
      signal,
    });

    if (response.status !== 200 && response.status !== 404) {
      throw new Error("Status:", response.status);
    }

    clearTimeout(id);
    return response;
  } catch (e) {
    console.warn("Error: could not complete network request to API:", e);
    presentNetworkError(url, method);
  }

  return new Error("Unsuccessful request");
};

const get = async (
  endpoint: string | number,
  onSuccess: (arg0: any) => void,
  onError: (arg0: any) => void
) => {
  const res = await makeRequest(endpoint, "get");
  if (res.status !== 200) {
    if (onError) {
      onError(await res.json());
    }
  } else if (res.status === 200) {
    if (onSuccess) {
      onSuccess(await res.json());
    }
  }
};

const post = async (
  endpoint: string | number,
  body: { [key: string]: unknown } | null,
  onSuccess: (arg0: any) => void,
  onError: (arg0: any) => void
) => {
  const res = await makeRequest(endpoint, "post", body);
  if (res.status !== 200) {
    if (onError) {
      onError(await res.json());
    }
  } else if (res.status === 200) {
    if (onSuccess) {
      onSuccess(await res.json());
    }
  }
};

const update = async (
  endpoint: string | number,
  body: null | {},
  onSuccess: (arg0: any) => void,
  onError: (arg0: any) => void
) => {
  const res = await makeRequest(endpoint, "put", body);
  if (res.status !== 200) {
    if (onError) {
      onError(await res.json());
    }
  } else if (res.status === 200) {
    if (onSuccess) {
      onSuccess(await res.json());
    }
  }
};

const remove = async (
  endpoint: string | number,
  body: { [key: string]: unknown } | null,
  onSuccess: (arg0: any) => void,
  onError: (arg0: any) => void
) => {
  const res = await makeRequest(endpoint, "delete", body);

  if (res.status !== 200) {
    if (onError) {
      onError(await res.json());
    }
  } else if (res.status === 200) {
    if (onSuccess) {
      onSuccess(await res.json());
    }
  }
};

const api = {
  baseUrl,
  get,
  post,
  update,
  remove,
};

export default api;
